import React from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../components/home/Hero";
import Impact from "../components/home/Impact";
import Campaigns from "../components/home/Campaigns";
import Testimonials from "../components/home/Testimonials";
import Gallery from "../components/home/Gallery";
import WhatWeDo from "../components/home/WhatWeDo";
import Volunteer from "../components/home/Volunteer";
import DonationPage from "../components/home/DonationPage";

const siteUrl = "https://www.sevaafoundation.com";
const defaultImage = `${siteUrl}/logo512.png`;

// Master Schema for the entire Foundation
const masterNgoSchema = {
  "@context": "https://schema.org",
  "@type": "NGO",
  name: "Sevaa Foundation",
  alternateName: "Swadesh Sevaa Charitable Foundation",
  url: siteUrl,
  logo: defaultImage,
  image: defaultImage,
  description:
    "Sevaa Foundation is a registered NGO in India working towards child education, healthcare, women empowerment, and hunger relief.",
  telephone: "+91-9910218596",
  areaServed: {
    "@type": "Country",
    name: "India",
  },
  foundingLocation: {
    "@type": "Country",
    name: "India",
  },
  knowsAbout: [
    "Child Education",
    "Healthcare Support",
    "Women Empowerment",
    "Hunger Support",
    "Charity",
    "Social Welfare",
  ],
  sameAs: ["https://www.sevaafoundation.com"],
};

const masterWebsiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  name: "SEVAA Foundation",
  alternateName: "Swadesh Sevaa Charitable Foundation",
  url: siteUrl,
  inLanguage: "en-IN",
};

const Home = () => {
  return (
    <>
      {/* MASTER HOMEPAGE SEO */}
      <Helmet>
        <title>
          SEVAA Foundation | NGO in India for Education & Healthcare
        </title>

        <meta
          name="description"
          content="SEVAA Foundation is a registered NGO in India supporting child education, healthcare, hunger relief, women empowerment, tree plantation and elderly care programs."
        />
        
        {/* Keywords tag is kept limited and natural. Google ignores it, but Bing/Yahoo sometimes look at it mildly. */}
        <meta
          name="keywords"
          content="Sevaa Foundation, NGO in India, Child Education NGO, Healthcare NGO, Donate to NGO, Swadesh Sevaa Charitable Foundation, Women Empowerment, Hunger Support Charity"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Sevaa Foundation" />
        <meta name="language" content="English, Hindi" />
        <meta name="theme-color" content="#0f766e" />

        <link rel="canonical" href={`${siteUrl}/`} />

        {/* Open Graph / Facebook / WhatsApp */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Sevaa Foundation" />
        <meta property="og:url" content={`${siteUrl}/`} />
        <meta
          property="og:title"
          content="SEVAA Foundation | NGO in India for Education & Healthcare"
        />
        <meta
          property="og:description"
          content="Support Sevaa Foundation's initiatives in education, healthcare, and hunger support. Every donation helps transform lives."
        />
        <meta property="og:image" content={defaultImage} />
        <meta property="og:image:alt" content="Sevaa Foundation NGO Logo" />
        <meta property="og:locale" content="en_IN" />

        <script type="application/ld+json">
          {JSON.stringify(masterNgoSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(masterWebsiteSchema)}
        </script>
      </Helmet>

      {/* PAGE CONTENT */}
      <div className="bg-gray-50 w-full overflow-hidden">
        <Hero />
        <WhatWeDo />
        <Impact />
        <Gallery />
        <Volunteer />
        <Campaigns />
        <Testimonials />
        <DonationPage />
      </div>
    </>
  );
};

export default Home;